import { useOutletContext, useParams } from 'react-router-dom';
import { forwardRef, useEffect, useRef, useState } from 'react';
import api from '../../../api/Apis';
import _ from 'lodash';
import AccordionSec, { AddCardButtonText, FrequentlyProducts, ReviewSection, SupplimentPopUp } from '../common';
import { Button } from '@mui/material';
import Rating from '@mui/material/Rating';
import VedioPlayer from '../../../Components/Common/VedioPlayer';
import SvgAnimationBackground from '../../../Components/Common/SvgAnimationBackground';
import { SecondSection, UniqueDeliveryComp } from '../common';
import ReviewComponent from '../../../Components/Common/RatingSection/ReviewComponent';
import ProductPageDesign, { DialogSectionCss, ProductPageFooter } from '../productPage.style';
import DialogComponent from '../../../Components/Common/DialogComponent';
import parse from 'html-react-parser';
import apiPaths from '../../../services/apPaths';
import StarIcon from '@mui/icons-material/Star';
import ProvenComponent from '../../../Components/provenComponent';

const AccordionProductSec = forwardRef(({ title, content, active, onToggle }, ref) => {
  const handleClick = () => {
    onToggle();
    const centerPosition = (document.documentElement.scrollHeight - window.innerHeight) / 5;

    window.scroll({
      top: centerPosition,
      behavior: 'smooth'
    });
  };


  return (
    <div className="accordion-item-div">
      <div className="accordion-title-div" onClick={handleClick}>
        <div className="accord-head">{title}</div>
        <div className="icon-accor">{active ? '-' : '+'}</div>
      </div>
      {active && <div className="accordion-content" ref={ref}>{content}</div>}
    </div>
  );
});

const AccordionInnerSec = forwardRef(({ product, }, ref) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const handleToggle = (index) => {

    setActiveIndex(activeIndex === index ? null : index);
  };

  const data = [
    { title: "WHAT IT DOES", content: product?.products?.description, for: "desktop_view", id: product?.products?.id },
    { title: "HOW TO USE", content: product?.products?.benefits, for: "desktop_view", id: product?.products?.id },
  ];

  return (
    <div className="accordin">
      {data?.map((value, index) => (
        <div key={index} className={`${value.for ? value.for : ""} accordion`}>
          {value?.content && (
            <AccordionProductSec
              title={value.title}
              content={parse(String(value.content))}
              active={activeIndex === value?.id + index}
              ref={ref}
              onToggle={() => handleToggle(value?.id + index)}
            />
          )}
        </div>
      ))}
    </div>
  );
})


export default function Product() {
  const props = useOutletContext();

  const { customerCheck, minCartAutoshipCheck, smartShipCheck, setInnerLoader } = props;
  let location = useParams();
  const { id, name, page } = location;
  const [productqty, setQty] = useState(1);
  const [product, setproduct] = useState();
  const [productvariantid, setproductvariantid] = useState();
  const [costtype, setcosttype] = useState([]);
  const [variantdetals, setvariantdetails] = useState();
  const [Logintoken, setToken] = useState()
  const [relatedData, setRelatedData] = useState();
  const [productDetailContent, setProductDetailContent] = useState();
  const [reviewData, setReviewData] = useState([]);
  const [open, setOpen] = useState(false);
  const [openReview, setOpenReview] = useState(false);
  const [openKosher, setOpenKosher] = useState(false)
  const [cartNotify, setCartNotify] = useState('')
  const [playingVideo, setPlayingVideo] = useState(null);
  const [showImage, setShowImage] = useState(true);
  const [scrolled, setScrolled] = useState(false);
  const [productImg, setProductImg] = useState()

  // For add to cart product/variant
  const myRef = useRef(null);
  const seeRef = useRef(null);
  const addToCart = async (id, quantity) => {
    const formData = {
      product_id: id, variant_id: productvariantid,
      token: Logintoken, quantity: quantity, is_autoship: _.find(costtype, { id: id })?.value === 'AutoShip' ? true : false
    };
    await api.addToCart(formData).then(res => {
      if (res?.data?.code === 1) {
        setCartNotify("Added To Cart")
        setTimeout(() => {
          setCartNotify('');
        }, 3000)
        // toast.success(res.data.message, { duration: 5 })
        props?.getMiniCartProduct("onLoadData", formData);
        props?.setshowminicart(true)
      }
    })
  }


  const handleScroll = () => {
    if (window.scrollY > 50) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);


  const ProductDataFunction = async (id) => {
    try {
      const res = await api.getProductByProductid(id);
      if (res?.data?.code === 1) {
        // setInnerLoader(false);
        setProductDetailContent(res?.data?.product_detail_data);
        setvariantdetails(res?.data?.products?.variants);
        setReviewData(res?.data?.reviews);
        setproduct(res?.data);
        setProductImg(res?.data?.products?.product_images[0])
        setQty(1);
        setRelatedData(res?.data?.frequently_bought_products);
      } else {
        console.error('API returned error code:', res?.data?.code);
      }
    } catch (error) {
      console.error('Error fetching product data:', error);
      router.back();
    }
  };

  useEffect(() => {
    const token = localStorage.getItem('Token') || null;
    setToken(token);
    setcosttype([{ id: id, value: "Normal" }]);
    if (id) {
      ProductDataFunction(id);
    }
  }, [location, id]);


  const ForRatingStar = (count = 0) => {
    const Rating = [];
    for (let i = 1; i <= count; i++) {
      Rating.push(<i className="fa fa-star" aria-hidden="true" key={i + 1}></i>);
    }
    return Rating;
  }

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const slidersBanner = useRef();
  const settings1 = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    pauseOnHover: false,
  };

  const BiotickKaireVideos = [
    {
      urlData: `${apiPaths.DOC_URL}${productImg?.image}`,
      thumbnail: `${apiPaths.DOC_URL}${productImg?.image}`,
      isImage: true,
    },
    {
      urlData: `https://player.vimeo.com/video/1005957632?autoplay=false&loop=0&autopause=1&controls=true`,
      thumbnail: '/images/biotic-man.jpg',
    },
    {
      urlData: "https://player.vimeo.com/video/1010759116?autoplay=false&loop=0&autopause=1&controls=true",
      thumbnail: '/images/girl-maritime.jpg',
    },
    {
      urlData: "https://player.vimeo.com/video/1005901656?autoplay=false&loop=0&autopause=1&controls=true",
      thumbnail: "/images/man-prime.jpg",
    },

  ]

  const BiotickSilverKaireVideos = [
    {
      urlData: `${apiPaths.DOC_URL}${productImg?.image}`,
      thumbnail: `${apiPaths.DOC_URL}${productImg?.image}`,
      urlData2: `${apiPaths.DOC_URL}${productImg?.image}`,
      thumbnail2: `${apiPaths.DOC_URL}${productImg?.image}`,
      isImage: true,
    },
    {
      urlData2: "https://player.vimeo.com/video/1053933481?autoplay=false&loop=0&autopause=1&controls=true",
      thumbnail2: "/images/man-prime-pic.jpg",
      urlData: "https://player.vimeo.com/video/1055079623?autoplay=false&loop=0&autopause=1&controls=true",
      thumbnail: "/images/silver-girl.jpg",
    },

  ]

  const Prime180kaireVideos = [
    {
      urlData: `${apiPaths.DOC_URL}${productImg?.image}`,
      thumbnail: `${apiPaths.DOC_URL}${productImg?.image}`,
      isImage: true,
    },
    {
      urlData: "https://player.vimeo.com/video/1053933481?autoplay=false&loop=0&autopause=1&controls=true",
      thumbnail: '/images/man-prime-pic.jpg',
    },

  ];

  const handleThumbnailClick = (index) => {
    if (BiotickKaireVideos[index].isImage) {
      setShowImage(prev => !prev);
      setPlayingVideo(null);
    } else {
      setPlayingVideo(index);
      setShowImage(false);
    }
  };

  const handleThumbnailSilverKaireClick = (index) => {
    if (BiotickSilverKaireVideos[index].isImage) {
      setShowImage(prev => !prev);
      setPlayingVideo(null);
    } else {
      setPlayingVideo(index);
      setShowImage(false);
    }
  };
  const handlePrime180KaireClick = (index) => {
    if (Prime180kaireVideos[index].isImage) {
      setShowImage(prev => !prev);
      setPlayingVideo(null);
    } else {
      setPlayingVideo(index);
      setShowImage(false);
    }
  };
  return (
    <>
      <head><title>{name?.replace(/_/g, ' ')}</title></head>
      {productDetailContent &&
        <ProductPageDesign bannerImage={productDetailContent?.banner_dummy_image} section2Image={productDetailContent?.section2_dummyImage}>
          {(product?.products?.promotion_image_desktop?.length > 0) &&
            <div className='discount_image'>
              <img src={`${apiPaths.DOC_URL}/${product?.products?.promotion_image_desktop}`} />
              <img src={`${apiPaths.DOC_URL}/${product?.products?.promotion_image_mobile}`} className="for_mob" />
            </div>
          }
          {/* {second section} */}
          <div className={`${product?.products?.promotion_image_desktop?.length > 0 ? "product-section-slider discount_image_active" : "product-section-slider"}`}>

            <div className="product-section-details">
              <div className='container'>
                <div className="row product_detail_container">
                  <div className="col-md-5">
                    <div className="product-image">
                      {product?.products?.product_images?.map((productDataimage, index) => (
                        <img src={`${apiPaths.DOC_URL}/${productDataimage['image']}`} key={index + 1} className="product_img" style={{ display: playingVideo === null ? 'block' : 'none' }} />
                      ))}
                      {productDetailContent?.id === 19 && playingVideo !== null && (
                        <div className="video-player">
                          <iframe
                            src={BiotickKaireVideos[playingVideo].urlData.replace('autoplay=false', 'autoplay=true')}
                            width="1000"
                            height="800"
                            frameBorder="0"
                            allow="autoplay; fullscreen;"
                            allowFullScreen
                          ></iframe>
                        </div>
                      )
                      }
                      {productDetailContent?.id === 19 &&
                        <div className='all-images-section'>
                          <div className="thumbnails">
                            {BiotickKaireVideos?.map((video, index) => (

                              <div
                                // className={`${playingVideo === index ? "biotickakire-video active" : "biotickakire-video"}`} 
                                className={`biotickakire-video ${playingVideo === index || (showImage && index === 0) ? "active" : ""}`}
                                key={index}

                              >
                                <img
                                  src={video.thumbnail}
                                  alt={`Thumbnail video ${index + 1}`}
                                  style={{ cursor: 'pointer', width: '100%', height: 'auto' }}
                                  onClick={() => handleThumbnailClick(index)}
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                      }

                      {((productDetailContent?.id === 7) || (productDetailContent?.id === 8)) &&
                        playingVideo !== null && (
                          <div className="video-player">
                            <iframe
                              src={productDetailContent?.id === 7 ? BiotickSilverKaireVideos[playingVideo]?.urlData : BiotickSilverKaireVideos[playingVideo]?.urlData2.replace('autoplay=false', 'autoplay=true')}
                              width="1000"
                              height="800"
                              frameBorder="0"
                              allow="autoplay; fullscreen;"
                              allowFullScreen
                            ></iframe>
                          </div>
                        )
                      }


                      {((productDetailContent?.id === 7) || (productDetailContent?.id === 8)) &&
                        (
                          <div className="thumbnails">
                            {BiotickSilverKaireVideos?.map((video, index) => (
                              <>
                                <div
                                  // className={`${playingVideo === index || video.isImage !== undefined ? "biotickakire-video active" : "biotickakire-video"}`} 
                                  className={`biotickakire-video ${playingVideo === index || (showImage && index === 0) ? "active" : ""}`}
                                  key={index}

                                >
                                  <img
                                    src={productDetailContent?.id === 7 ? video.thumbnail : video.thumbnail2}
                                    alt={`Thumbnail video ${index + 1}`}
                                    style={{ cursor: 'pointer', width: '100%', height: 'auto' }}
                                    onClick={() => handleThumbnailSilverKaireClick(index)}
                                  />
                                </div>
                              </>
                            ))}
                          </div>
                        )}
                      {(productDetailContent?.id === 4) &&
                        playingVideo !== null && (
                          <div className="video-player">
                            <iframe
                              src={Prime180kaireVideos[playingVideo]?.urlData.replace('autoplay=false', 'autoplay=true')}
                              width="1000"
                              height="800"
                              frameBorder="0"
                              allow="autoplay; fullscreen;"
                              allowFullScreen
                            ></iframe>
                          </div>
                        )
                      }
                      {(productDetailContent?.id === 4) &&
                        (
                          <div className="thumbnails">
                            {Prime180kaireVideos?.map((video, index) => (
                              <>
                                <div
                                  // className={`${playingVideo === index || video.isImage !== undefined ? "biotickakire-video active" : "biotickakire-video"}`} 
                                  className={`biotickakire-video ${playingVideo === index || (showImage && index === 0) ? "active" : ""}`}
                                  key={index}
                                >
                                  <img
                                    src={video.thumbnail}
                                    alt={`Thumbnail video ${index + 1}`}
                                    style={{ cursor: 'pointer', width: '100%', height: 'auto' }}
                                    onClick={() => handlePrime180KaireClick(index)}
                                  />
                                </div>

                              </>
                            ))}
                          </div>
                        )}
                    </div>
                  </div>


                  <div className="col-md-7">
                    <div className="custom-cont">
                      <div className="first_section">
                        <h2 className="title">{product?.products?.name &&
                          `${product?.product_name || ""} ${product?.products?.name || ""}`}
                          {product?.products?.name !== "BioticKaire+" && product?.products?.name !== "SilverKaire" &&
                            <sup style={{ fontSize: '18px' }}>TM</sup>}
                        </h2>
                        <span>{productDetailContent?.asked_section && parse(productDetailContent?.asked_section)}</span>
                      </div>
                      <SecondSection data={{
                        smartShipCheck,
                        costtype,
                        setcosttype,
                        id: id,
                        minCartAutoshipCheck,
                        productCost: product?.products.cost_price,
                        productSmartShip: product?.products.autoship_cost_price
                      }} />
                      <div className="third_section">
                        <div className="quantity_section box">
                          <span><b>Qty:</b></span>
                          <div id="qty">
                            <button type="button" id="sub" className="sub" onClick={(e) => {
                              setQty(productqty > 1 ? productqty - 1 : productqty)
                            }}>-</button>
                            <input type="text" value={productqty} name="qty" onChange={(e) => {
                              setQty(e.target.value)
                            }} min="1" max={product?.products?.quantity} readOnly />
                            <button type="button" id="add" className="add" onClick={(e) => {
                              setQty(productqty + 1);
                            }}>+</button>
                          </div>
                        </div>
                        <div className="add_button_div">
                          <div className={`btn-sec Add_to_cart ${product?.products?.is_stock_available === 'True' ? '' : 'out-of-stock'}`} >
                            <button disabled={product?.products?.is_stock_available === 'True' ? false : true}
                              type="button" id={product?.products?.id}
                              onClick={(e) => addToCart(id, productqty)}>
                              {AddCardButtonText(product?.products?.is_stock_available, costtype, id)}
                            </button>
                          </div>
                        </div>

                      </div>
                      <div className="fourth_section">
                        <div className="review-section-now">
                          {props.isLogin || Logintoken !== null &&
                            <p>BV: {(_.find(costtype, { id: id })?.value === 'AutoShip' || minCartAutoshipCheck === "True") ? product?.products?.autoship_bonus_value.split()[0] : product?.products?.bonus_value} </p>
                          }
                          <ul>
                            <li>
                              <Rating
                                name="rating"
                                value={4}
                                readOnly
                                precision={0.5}
                                sx={{ color: "black" }}
                                emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />}
                              />
                            </li>
                            <li className="review_list" onClick={() => myRef.current.scrollIntoView()}>
                              <a href="#" style={{ pointerEvents: "none" }}>{reviewData?.length} reviews</a>
                            </li>
                            {props.isLogin || Logintoken !== null &&
                              <>
                                <li><span className="breaker">|</span><button onClick={() => setOpenReview(true)} style={{ background: "none", padding: 0 }}>Write a review</button></li>
                                <ReviewComponent productId={id} productName={name?.replaceAll('_', " ")} section="product_page" open={openReview} handleClose={setOpenReview} setOpen={setOpen} reviewData={reviewData} setReviewData={setReviewData} />
                              </>
                            }
                          </ul>
                        </div>
                        {productDetailContent?.supplement_facts &&
                          <>
                            <div className="supplement-fact">
                              <Button className="subpplement_button" onClick={() => handleClickOpen()}>Supplement Facts</Button>
                              {/*{props.isLogin === true &&
                            <Button id={product?.products?.id} onClick={(e) => addToWishList(e)}>Add to WishList</Button>
                          }*/}
                              <SupplimentPopUp handleClose={handleClose} open={open} image={productDetailContent?.supplement_facts} />
                            </div>
                            {productDetailContent?.id !== 19 && productDetailContent?.id !== 7 &&
                              <div className="Kosher">
                                <a style={{ cursor: 'pointer' }} onClick={() => setOpenKosher(true)} className="par-logo">  <img src="/KosherLogo-ai.png" /><p><span>?</span>
                                  what is Kosher</p>
                                </a>
                              </div>
                            }
                            <DialogComponent opend={openKosher} handleClose={() => setOpenKosher(false)} title="Description" classFor="order_details">
                              <DialogSectionCss>
                                <div className="head_kosher">
                                  <h3>What is Kosher & What Does It Mean?</h3>
                                </div>

                                <p> According to the kldbkosher.org website, “Kosher is a Hebrew word that means fit, proper, or correct.
                                  Nowadays, it is mostly used to describe food and drink that complies with Jewish religious dietary law.”</p>

                                <div className="certified">
                                  <h3> What is Kosher Certified?</h3>
                                </div>
                                <p> For a product to be kosher certified, and to qualify for a kosher certificate, each ingredient, food additive,
                                  and processing aid used in its production must also be kosher. Additionally, to be kosher certified,
                                  the production process must be suitable for kosher requirements and therefore it must be approved by a kosher auditor.
                                  Products may be rendered non-kosher if their production lines and equipment are also used to manufacture non-kosher products.</p>

                              </DialogSectionCss>
                            </DialogComponent>
                          </>
                        }

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion-item-product-sec" id="content-more" >
              <div className="accordion-title-inner container" >
                <AccordionInnerSec product={product} ref={seeRef} />
              </div>
            </div>



            {productDetailContent?.id === 8 &&
              <div className="product-discript-sec-main Maritime_120_section">
                <div className='container'>
                  <div className='main-banner-section'>
                    <div className='left-side-image'>
                      <h2 className='heading-font home-heading-common'>Why Super Maritime Prime 120™ Pycnogenol<sup>®</sup>?</h2>
                      <div className='left-wrapper'>
                        <div className="product-image">
                          <div className="video-player">
                            <iframe
                              src="https://player.vimeo.com/video/1053933481?autoplay=false&loop=0&autopause=1&controls=true"
                              width="1000"
                              height="800"
                              frameBorder="0"
                              allow="autoplay; fullscreen;"
                              allowFullScreen
                            ></iframe>
                          </div>
                        </div>
                        <div className='list-item-content'>
                          <ul>
                            <li>Certified Kosher, Vegan and Gluten Free</li>
                            <li>
                              4X More Effective Than store-bought" Brands
                            </li>
                            <li>One of the Richest Antioxidants
                              Available</li>
                            <li>60 mg Per Tablet </li>
                            <li>Powerful Anti-Inflammatory</li>
                            <li>
                              Proprietary plant-based enzyme delivery
                              system designed for optimal efficacy
                              and bioavailability
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className='right-side-text'>
                      <div className='inside-right-sec'>

                        <div className='inner-img-div'>
                          <img src='/images/120layerimg.jpg' />
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>

            }

            {productDetailContent?.id === 19 &&
              <div className="product-discript-sec-main biotic_kaire_section">
                <div className='container'>
                  <div className='main-banner-section'>
                    <div className='left-side-image'>
                      <h2 className='heading-font home-heading-common'>Why BioticKaire+ with Pre-Pro-Post Biotics & Digestive Enzymes?</h2>
                      <div className='left-wrapper'>
                        <div className="product-image">
                          <div className="video-player">
                            <iframe
                              src="https://player.vimeo.com/video/1010759116?autoplay=false&loop=0&autopause=1&controls=true"
                              width="1000"
                              height="800"
                              frameBorder="0"
                              allow="autoplay; fullscreen;"
                              allowFullScreen
                            ></iframe>
                          </div>
                        </div>
                        <div className='list-item-content'>

                          <ul>

                            <li>Comprehensive 4-in- Formula</li>
                            <li>Advanced Probiotic Strains</li>
                            <li>Innovative Prebiotic Support</li>
                            <li>Postbiotic Inclusion</li>
                            <li>Broad Spectrum Digestive Enzymes</li>
                            <li>Scientifically Backed Ingredients</li>
                            <li>Health Benefits Beyond Digestion</li>

                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className='right-side-text'>
                      <div className='inside-right-sec'>

                        <div className='inner-img-div'>
                          <img src='/images/BioticKairelayerImg.jpg' />
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }


            {productDetailContent?.id === 7 &&

              <div className="product-discript-sec-main Silver_kaire_section">
                <div className='container'>
                  <div className='main-banner-section'>
                    <div className='left-side-image'>
                      <h2 className='heading-font home-heading-common'>Why SilverKaire Silver?</h2>
                      <div className='left-wrapper'>
                        <div className="product-image">
                          <div className="video-player">
                            <iframe
                              src="https://player.vimeo.com/video/1055079623?autoplay=false&loop=0&autopause=1&controls=true"
                              width="1000"
                              height="800"
                              frameBorder="0"
                              allow="autoplay; fullscreen;"
                              allowFullScreen
                            ></iframe>
                          </div>
                        </div>

                        <div className='list-item-content'>
                          <ul>
                            <li>Antibacterial Efficacy</li >
                            <li>Enhanced Absorption</li>
                            <li>Probiotic Compatibility</li>
                            <li>Comprehensive Health Support</li>
                            <li>Safety Profile</li>
                            <li>Rapid Elimination</li>
                            <li>Scientific Validation</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className='right-side-text'>
                      <div className='inside-right-sec'>

                        <div className='inner-img-div'>
                          <img src='/images/silverkarirelayer.png' />
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>

            }

            {productDetailContent?.id === 4 &&
              <div className="product-discript-sec-main Prime_180_section">
                <div className='container'>
                  <div className='main-banner-section'>
                    <div className='left-side-image'>
                      <h2 className='heading-font home-heading-common'>Why Maritime Prime 180™ Pycnogenol<sup>®</sup>?</h2>
                      <div className='left-wrapper'>
                        <div className="product-image">
                          <div className="video-player">
                            <iframe
                              src="https://player.vimeo.com/video/1053933481?autoplay=false&loop=0&autopause=1&controls=true"
                              frameBorder="0"
                              allow="autoplay; fullscreen;"
                              allowFullScreen
                            ></iframe>
                          </div>
                        </div>
                        <div className='list-item-content'>
                          <ul>
                            <li>Certified Kosher, Vegan and Gluten Free</li>
                            <li>4X More Effective Than store-bought' Brands</li>
                            <li>One of the Richest Antioxidants Available</li>
                            <li>Smaller for Effortless Swallowing</li>
                            <li>20 mg per tablet</li>
                            <li>Powerful Anti-Inflammatory</li>
                            <li> Proprietary plant-based enzyme delivery
                              system designed for optimal efficacy
                              and bioavailability</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className='right-side-text'>
                      <div className='inside-right-sec'>

                        <div className='inner-img-div'>
                          <img src='/images/180layerimg.jpg' />
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }


            <div className='proven-benefits section'>
              <div className='container'>
                <ProvenComponent productDetailContent={productDetailContent} costtype={costtype} />
              </div>
            </div>
          </div>

          <div className="customer-review-now" ref={myRef}>
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="review-customer">
                    <h5>What are people saying about this product?</h5>
                    <h2>Customer Reviews</h2>
                  </div>
                </div>
              </div>
              <div id="review">
                <ReviewSection ForRatingStar={ForRatingStar} reviewData={reviewData} setReviewData={setReviewData} />
              </div>
            </div>

          </div>
          <SvgAnimationBackground />
          <ProductPageFooter>
            <div className={`${scrolled ? 'price_section_footer scrolled' : 'price_section_footer'}`}>
              <div className='price-sec'>
                <div className="price-inner-sec">
                  <SecondSection data={{
                    smartShipCheck,
                    costtype,
                    setcosttype,
                    id: id,
                    minCartAutoshipCheck,
                    productCost: product?.products.cost_price,
                    productSmartShip: product?.products.autoship_cost_price
                  }} />
                  {/* {(customerCheck > 1) && */}
                  {props.isLogin &&
                    <h5 className="bonus_value">BV: {(_.find(costtype, { id: id })?.value === 'AutoShip' || minCartAutoshipCheck === "True") ? product?.products?.autoship_bonus_value.split()[0] : product?.products?.bonus_value} </h5>
                  }
                  {/* } */}
                </div>
                <div className="footer-merge">
                  <div className="quality">
                    <div className="main-qty-sec">
                      <div className="box">
                        <div id="qty">
                          <button type="button" id="sub" className="sub" onClick={(e) => {
                            setQty(productqty > 1 ? productqty - 1 : productqty)
                          }}>-</button>
                          <input type="text" value={productqty} name="qty" onChange={(e) => {
                            setQty(e.target.value)
                          }} min="1" max={product?.products?.quantity} readOnly />
                          <button type="button" id="add" className="add" onClick={(e) => {
                            setQty(productqty + 1);
                          }}>+</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="cart-add">
                    {/* {operation === 'showpopup' && <Popups message={addtocartmessage} />} */}
                    <div className="add_button_div">
                      <div className={`btn-sec Add_to_cart ${product?.products?.is_stock_available === 'True' ? '' : 'out-of-stock'}`} >
                        <button className="add_margin" disabled={product?.products?.is_stock_available === 'True' ? false : true}
                          type="button" id={product?.products?.id}
                          onClick={(e) => addToCart(id, productqty)}>
                          {AddCardButtonText(product?.products?.is_stock_available, costtype, id)}
                        </button>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ProductPageFooter>
        </ProductPageDesign >
      }
    </>
  )
}

export const getStaticPaths = async ({ id }) => {
  let paths;
  const defaultValues = {
    paths: [],
    fallback: true,
  };

  try {
    // const allSlugs = ["us/product/Test2%20Product/12/", "us/product/Test3%20Product/13/"];
    const res = await fetch(`${apiPaths.DOC_URL.getAllProduct}?slug=us`)
    let data_page = await res?.json();
    data_page = data_page?.products
    paths = data_page?.map((c) => {
      let names = c?.name.replace('25%', '')
      let catname = names.replace('\t', '')
      catname = catname.replace(/\s/g, '_');
      return (`/us/product/${catname}/${c?.id}`)
    });    // paths = allSlugs.map((slug) => "/" + slug);

  } catch (e) { return defaultValues; }
  return {
    paths,
    fallback: true,
  };
};

export const getStaticProps = async ({ params: { page, id } }) => {
  const res = await fetch(`${apiPaths.DOC_URL.getAllProduct}?slug=us`)
  let data_page = await res.json();
  // data_page = data_page//?.products
  return {
    props: {
      id, data_page
    },
    revalidate: 60,
  };
};